import CompaniesListing from './CustomersListing';

export default CompaniesListing;
